const initSwiper = (options) => {
  return new Swiper('.swiper', options);
};

const updateSwiperOptions = (swiper) => {
  if (window.innerWidth <= 768) {
    swiper.params.spaceBetween = 16;
  } else {
    swiper.params.spaceBetween = 48;
  }
  swiper.update();
};

const setSlidesEqualHeight = () => {
  const slides = document.querySelectorAll('.swiper-slide');
  let maxHeight = 0;

  // 全てのスライドの最大高さを計算
  slides.forEach((slide) => {
    slide.style.height = 'auto'; // 初期状態に戻す
    const slideHeight = slide.clientHeight;
    if (slideHeight > maxHeight) {
      maxHeight = slideHeight;
    }
  });

  // 全てのスライドの高さを最大高さに設定
  slides.forEach((slide) => {
    slide.style.height = `${maxHeight}px`;
  });
};

const swipe = () => {
  const elmn = document.querySelectorAll(".swiper");
  if (elmn.length) {
    let swiperOptions = {
      loop: false,
      centeredSlides: false,
      slidesPerView: 'auto',
      spaceBetween: 48,
      speed: 600,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true
      }
    };

    const swiper = initSwiper(swiperOptions);
    updateSwiperOptions(swiper);
    setSlidesEqualHeight(); // 初期化時に高さを調整

    window.addEventListener('resize', () => {
      updateSwiperOptions(swiper);
      setSlidesEqualHeight(); // リサイズ時に高さを再調整
    });
  }
};
